import { FC } from 'react'
import { cn } from '@oasisprotocol/ui-library/src/lib/utils'

/** OXN brand mark (kept export name for existing imports). */
export const OasisIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      className={cn('h-8 w-8 sm:h-10 sm:w-10', className)}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="oxnMarkGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#1D8BF1" />
          <stop offset="1" stopColor="#0A3A84" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="9" fill="url(#oxnMarkGrad)" />
      <path
        d="M6 18.5c2.5 0 2.5-2.6 5-2.6s2.5 2.6 5 2.6 2.5-2.6 5-2.6 2.5 2.6 5 2.6"
        fill="none"
        stroke="#fff"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <path
        d="M6 23.5c2.5 0 2.5-2.6 5-2.6s2.5 2.6 5 2.6 2.5-2.6 5-2.6 2.5 2.6 5 2.6"
        fill="none"
        stroke="#8FD8FF"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <circle cx="22.5" cy="10" r="2.6" fill="#fff" />
    </svg>
  )
}
